import { ElementRef } from '@angular/core';
import { AfterViewInit, Component, ViewChild, OnInit } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import * as xlsx from 'xlsx';
import { Router } from '@angular/router';
import { APIService } from 'src/app/api.service';
import { CommonService } from 'src/app/services/common.service';
import { Observable, Subject } from 'rxjs';


 interface monthlist {
   display: string;
 }

@Component({
  selector: 'app-consolidated-stock-transactions',
  templateUrl: './consolidated-stock-transactions.component.html',
  styleUrls: ['./consolidated-stock-transactions.component.scss']
})
export class ConsolidatedStockTransactionsComponent implements AfterViewInit, OnInit {


  displayedColumns: string[] = ['ItemName','categoryName','subCategoryName','DispatchQty','consumption','ProductionQty','InwardQty','ReconciliationQty','Unit'];
 // displayedColumns: string[] = ['item','category','unit','purchase','rtnunused','issue','delivery','scrap','rcnpluse','rcnminus','closing'];

 dataSource = new MatTableDataSource();


  curDate: any = new Date();
  months: any = [];
  monthDisplay: any = [];
  IsPrevios = 0;
  agencyData: any;
  jarvisData: any;
  type:any =  "MM";
  month = this.curDate.getMonth();
  year = this.curDate.getFullYear();
  consloiteditemtrasHtryList: any;
  tagData: any= [];
  categories: any;
  subCat: any;
  fromDate: any;
  toDate: any;
  ERP_Agn: any = [];
  accountDate: any = [];
  selectedFY: any;
  financialYears: any = [];
  exportToExcel: any = [];
  display: string = '';
  fromMinDate: any;
  selectedDate: any;
  acctStartDT: Date = new Date();

  
  @ViewChild('csttable', { static: false }) csttable!: ElementRef;
  //acctStartDT!: Date;
  selectedMonthName: any;
  item: any = [];
  getFullYear: any;
  filter: any;
  
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  @ViewChild(MatPaginator) 
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  } 
  
  button: boolean = false;
  period = 0;
  periodtrans = 1;

  constructor(private router: Router,  private commonService: CommonService, private apiService: APIService) { }
    view = {
      month: (this.curDate.getMonth() + 1).toString(),
      year: (this.curDate.getFullYear()).toString(),
      fy : '',
    }

  ngOnInit(): void {
    
    this.months = this.commonService.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#"));
    this.monthDisplay = this.months[this.months.length - 1].display;
  
    
    this.financialYears = this.commonService.checkFinancialYear(new Date('2019-Apr-01'), new Date());

    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }
    this.typeFilter(1);
  }

  trasYearChange() {
    let selecetdYear = this.months.filter((a: any) => a.display == this.monthDisplay);
    this.view.year = selecetdYear[0].year;
    this.view.month = selecetdYear[0].number;
    this.getData();
  }

  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
      , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

    return function (table: any, name: string, fileName: any) {
      if (!table.nodeType) table = table
      var ctx = { worksheet: name || 'Worksheet', table: table }
      //window.location.href = uri + base64(format(template, ctx))
      var link = document.createElement("a");
      link.download = fileName || 'download.xls';
      link.href = uri + base64(format(template, ctx));
      link.click();
    }
  })()

  getData() {
      let jarvis: any = this.apiService.getCookie('Jarvis');
      if (jarvis) {
        this.jarvisData = JSON.parse(jarvis);
      }
      
      let agencyData = this.apiService.getCookie('M');
      if (agencyData) {
        this.agencyData = JSON.parse(agencyData);
      }
      
      let data = [
        {
          Month: this.view.month,
          Year: this.view.year,
          Type: this.type,
        },
      ];
      let myParams = [
        {
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          myLastSyncDT: null,
          isWeb: true,
          ForERPAgencyID: this.agencyData[0].ERPAgencyID,
          actionType: 'getConsoltdStkTrans',
          moduleID: 12,
          data: JSON.stringify(data),
        },
      ];
  
      this.apiService.getData(myParams, this.consolitedStocksuccessResp.bind(this), this.consolitedStockfailureResp.bind(this)
      );
    }
  
  consolitedStocksuccessResp(res: any) {
      // this.SpinnerService.hide();
      if (res.error) {
      }
      else {
        if (res) {
          var reponseData = JSON.parse(res.updatePackage);
          if (reponseData.Table[0].ErrCode == 1000) {
            alert(reponseData.Table[0].ErrMsg);
          } else {
            if (reponseData.Table[0].ErrCode == -1) {
              this.consloiteditemtrasHtryList = reponseData.Table1;
              //this.itemtrasactionHistoryList = reponseData.Table2;
              let tmpERP_Cfg = this.apiService.getCookie("ERP_Cfg");
              if(tmpERP_Cfg){
                this.tagData =  JSON.parse(tmpERP_Cfg);
                if(this.tagData){
                  this.categories = JSON.parse(this.tagData[0].ItemCategories);
                 
                }
              }
            
            
              this.consloiteditemtrasHtryList.forEach((p: any) => {
                // p.CurrQty = Number(p.CurrQty).toFixed(p.SKUPrecision);
                p.consumption = p.IssuedQty - p.UnUsedQty;
                p.ReconciliationQty = p.ReconciliationInQty - p.ReconciliationOutQty;
                let CatData = this.categories.filter((x: any) => x.cid == p.CategoryID);
                if(CatData.length > 0){
                  p.categoryName = CatData[0].cnm;
                  if (CatData[0].sub) {
                      let subCategoryList = (CatData[0].sub);
                      let subCat = subCategoryList.filter((x: any) => x.sid == p.SubCategoryID);
                      if(subCat.length > 0){
                        p.subCategoryName = subCat[0].snm ? subCat[0].snm : '';
                      }
                  }
                  
                }
                p.consumption = Number(p.consumption).toFixed(p.SKUPrecision)
                p.ReconciliationQty =Number(p.ReconciliationQty).toFixed(p.SKUPrecision)
                p.InwardQty = Number(p.InwardQty).toFixed(p.SKUPrecision)
                p.ProductionQty = Number(p.ProductionQty).toFixed(p.SKUPrecision)
                p.DispatchQty = Number(p.DispatchQty).toFixed(p.SKUPrecision)

              
            });
              this.dataSource.data = this.consloiteditemtrasHtryList;
              this.exportToExcel = this.consloiteditemtrasHtryList;
              this.dataSource.sort = this.matSort;
              this.item =  this.dataSource.data;

          }
        }
        
      }
    }
  
  }

  //failureResp - failure handler
  consolitedStockfailureResp(res: any) {
    if (res.error) {
    } else {
      alert(res.message);
    }
    
  }
  
  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }

  typeFilter = (obj: any) => {
    this.period = obj
    this.year = this.curDate.getFullYear();
    this.view.year = this.year;

    if (this.period == 1) {
      this.type = "MM"
      this.view.year = this.curDate.getFullYear();
      this.view.month = this.curDate.getMonth() + 1;
    }
    else if (this.period == 2) {
      this.type = "MM"
      this.view.year = this.curDate.getFullYear();
      this.view.month = this.curDate.getMonth();
      if (this.view.month == 0) {
        this.view.month = this.curDate.getMonth() - 1;
      }
    }
    else if (this.period == 3) {
      this.type = "YY";
      let currFinYear: any = this.commonService.getCurrentFinancialYear(new Date());
      this.view.fy = currFinYear;
      this.view.year = currFinYear.split("-")[0];
      this.view.month = "4";
     
    }
    else if (this.period  == 5) {
      this.type = "MM"
      this.view.year = this.curDate.getFullYear();
      this.view.month = this.curDate.getMonth() + 1;
      this.trasYearChange();
    }

    this.getData();
  }

  typeFilterTrans = (obj: any) => {
    this.periodtrans = obj;
    if (this.periodtrans == 1) {
      this.exportToExcel = this.dataSource.data;
    }
    else if (this.periodtrans == 2) {
      this.exportToExcel = this.dataSource.data;
    }
    else if (this.periodtrans == 3) {
      this.exportToExcel = this.dataSource.data;
    }
  
  }

  //common search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

//export to excel
exportToExcelActivities() {
      var html = "";
      html += "<table><tr>";
      html += "<th style='text-align: left;'>Consolidated Stock Transactions</th>"
      html += "</table></tr>";
      html += "<table><tr></table></tr>";
      // // Title
      // var FileName = this.period == 1 ? 'This Month' : this.period == 2 ? 'Last Month' : this.period == 3 ? 'Fin yr' : this.period == 4 ? 'Last Fin yr' : this.period == 5 ? 'Other' : '';
      // html += "<table><tr>";
      // html += "<th style='text-align: left;'>" + FileName + "</th>"

      if (this.period == 1) {
        var  monthlist = this.months.filter((a: any) => a.number == this.view.month && a.year == this.view.year);
          if (monthlist.length > 0) {
              html += "<p><b>Month : </b>" + monthlist[0].display + "</p>"
          }
      }
      else if (this.period == 2) {
        monthlist = this.months.filter((a: any) => a.number == this.view.month && a.year == this.view.year);
        if (monthlist.length > 0) {
            html += "<p><b>Month : </b>" + monthlist[0].display + "</p>"
        }
      }
      else if (this.period == 3) {
        // this.view.year = currFinYear.split("-")[0];
        // let startDTofCurr = '1-Apr-' + this.curDate.getFullYear();
        // let endDTofCurr = '31-Mar-' + this.curDate.getFullYear();
        html += "<p><b>Fin Years: </b>" + this.view.fy + "</p>"
    }        
      
      html += "</table></tr>";
      html += "</table></tr>";
      
      if(this.period == 5){
      html += "<p><b>  Month : </b>"+ this.monthDisplay +  "</p>"
      }

      // Blank Column
      html += "<table><tr></table></tr>";
      html += "<table><tr>";

  var strHeader = ""
  strHeader += "<th style='text-align: left;'>Item</th>";
  strHeader += "<th style='text-align: left;'>Category</th>";
  strHeader += "<th style='text-align: left;'>Sub-Category</th>";
  if(this.periodtrans == 2 || this.periodtrans == 1){
    strHeader += "<th style='text-align: right;'>Dispatch</th>";
  }
  if(this.periodtrans == 3 || this.periodtrans == 1)
  {
    strHeader += "<th style='text-align: right;'>Consumption</th>";

  }
  if(this.periodtrans == 3 || this.periodtrans == 1)
  {
    strHeader += "<th style='text-align: right;'>Production</th>";
  }
  if(this.periodtrans == 2 || this.periodtrans == 1){
    strHeader += "<th style='text-align: right;'>Inward</th>";
  }
  if(this.periodtrans == 3 || this.periodtrans == 1){
    strHeader += "<th style='text-align: right;'>Reconciliation</th>";
  }
  strHeader += "<th style='text-align: left;'>Unit </th>";

  strHeader += "</tr>"

  html += strHeader;

  var body = "";
  this.exportToExcel.forEach((consloiteditemtrasHtryList:any, key:any) => {
    body += "<tr>";
    body += "<td style='text-align: left;'>" + consloiteditemtrasHtryList.ItemName + "</td>";
    body += "<td style='text-align: left;'>" + consloiteditemtrasHtryList.categoryName  + "</td>";
    body += "<td style='text-align: left;'>" + consloiteditemtrasHtryList.subCategoryName  + "</td>";
    if(this.periodtrans == 2 || this.periodtrans == 1){
    body += "<td style='text-align: right;'>" + consloiteditemtrasHtryList.DispatchQty  + "</td>";
    }
    if(this.periodtrans == 3 || this.periodtrans == 1){
    body += "<td style='text-align: right;'>" + consloiteditemtrasHtryList.consumption  + "</td>";
    }
    if(this.periodtrans == 3 || this.periodtrans == 1){
    body += "<td style='text-align: right;'>" + consloiteditemtrasHtryList.ProductionQty  + "</td>";
    }
    if(this.periodtrans == 2 || this.periodtrans == 1){
    body += "<td style='text-align: right;'>" + consloiteditemtrasHtryList.InwardQty  + "</td>";
    }
    if(this.periodtrans == 3 || this.periodtrans == 1){
    body += "<td style='text-align: right;'>" + consloiteditemtrasHtryList.ReconciliationQty  + "</td>";
    }
    body += "<td style='text-align: left;'>" + consloiteditemtrasHtryList.Unit  + "</td>";
   
  body += "</tr>";
  })

 
  html += body;
  html += "</table>";
  this.tableToExcel(html, 'Sheet1', 'Consolidated Stock Transactions');
}

ddlchangeYear() {
  if (this.view.fy != 'Other') {
    let selectedYear: any = [];
    selectedYear = this.view.fy.split("-");
    this.view.year = selectedYear[0];
    this.view.month = "4";
    this.type = "YY"
    this.getData();
  }
}

backBtn() {
  this.router.navigate(['/Stock']);
}

}
function data(data: any) {
  throw new Error('Function not implemented.');
}


function ToDT(ToDT: any, any: any) {
  throw new Error('Function not implemented.');
}
